module.exports = __webpack_public_path__ + "img/banking-providers.1eafc7e.png";